if (!customElements.get('woof-story-slider')) {
  class WoofStorySlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-story-viewport]');
      this.dots = Array.from(this.querySelectorAll('[data-story-dot]'));
      this.slides = Array.from(this.querySelectorAll('[data-story-slide]'));
      if (!this.viewport || this.dots.length < 2 || this.slides.length < 2) return;

      this.viewport.removeEventListener('scroll', this.handleScroll);
      this.dotHandlers?.forEach(({ dot, handler }) => dot.removeEventListener('click', handler));
      this.dotHandlers = this.dots.map((dot, index) => {
        const handler = () => {
          this.goTo(index);
        };
        dot.addEventListener('click', handler);
        return { dot, handler };
      });
      this.handleScroll = () => this.scheduleUpdate();

      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateDots());
      this.resizeObserver.observe(this.viewport);
      this.setAttribute('data-slider-ready', 'true');
      this.updateDots();
    }

    disconnectedCallback() {
      this.dotHandlers?.forEach(({ dot, handler }) => dot.removeEventListener('click', handler));
      this.viewport?.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    goTo(index) {
      const firstSlideLeft = this.slides[0].offsetLeft;
      const targetSlide = this.slides[Math.min(index, this.getPageCount() - 1)];
      const target = targetSlide.offsetLeft - firstSlideLeft;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    scheduleUpdate() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.updateDots());
    }

    updateDots() {
      const pageCount = this.getPageCount();
      const firstSlideLeft = this.slides[0].offsetLeft;
      let activeIndex = 0;
      let shortestDistance = Number.POSITIVE_INFINITY;

      this.slides.slice(0, pageCount).forEach((slide, index) => {
        const slidePosition = slide.offsetLeft - firstSlideLeft;
        const distance = Math.abs(this.viewport.scrollLeft - slidePosition);
        if (distance < shortestDistance) {
          shortestDistance = distance;
          activeIndex = index;
        }
      });

      this.dots.forEach((dot, index) => {
        dot.hidden = index >= pageCount;
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    getPageCount() {
      const slideWidth = this.slides[0].getBoundingClientRect().width;
      const visibleSlides = Math.max(1, Math.round(this.viewport.clientWidth / slideWidth));
      return Math.max(1, this.slides.length - visibleSlides + 1);
    }
  }

  customElements.define('woof-story-slider', WoofStorySlider);
}
